import axios from "axios";
import Config from "../../../config";

const v2_actionAddParticipants = (chatId, waIds) => axios({
    method: "post",
    url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/groups/${chatId}/participants`,
    data: { waIds }
});

export default v2_actionAddParticipants;
